import React from "react";
import { Link } from "react-router-dom";
import "../Css/Hero.css";

import hero1Main from "../assets/aaa.png";
import hero1Top from "../assets/housemaid.jpg";

import About from "./About";
import Services from "../Components/Services";
import CTA from "../Components/CTA";
import WhyChoose from "../Components/WhyChoose";
// import Testimonial from "../Components/Testimonial";
import ReviewWidget from "../Components/ReviewWidget";

import Popup from "../Components/Popup.jsx";

const Hero = () => {
  return (
    <>
      <Popup />

      {/* ================= HERO ================= */}
      <section className="hero">

        {/* Main Background */}
        <img
          src={hero1Main}
          alt="Maid Service in Mumbai"
          className="hero-bg hero-bg-main"
        />

        {/* Top Overlay Image */}
        <img
          src={hero1Top}
          alt="Verified and Reliable Maid Service in Mumbai"
          className="hero-bg hero-bg-top"
        />

        {/* Overlay */}
        <div className="hero-overlay"></div>

        {/* Content */}
        <div className="hero-content">

          <h1 className="hero-title">
            Maid Service in Mumbai{" "}
            <span>Verified & Reliable Maids</span>
          </h1>

          <p className="hero-desc">
            Reliable and professional maid services for daily household
            needs. Trusted, trained, and verified staff to keep your home
            clean and comfortable.
          </p>

          <div className="hero-buttons">

            <Link
              to="/about-us"
              className="btn primary"
            >
              Discover More
            </Link>

            <Link
              to="/contact"
              className="btn outline"
            >
              Contact Us
            </Link>

          </div>
        </div>

      </section>

      {/* ================= OTHER SECTIONS ================= */}

      <About />
      <Services />
      <CTA />
      <WhyChoose />
      {/* <Testimonial /> */}
      <ReviewWidget />

      {/* ================= MAP ================= */}

      <section className="contact-map">
        <iframe
          title="SVK Maid Services Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7541.039524177508!2d72.90551!3d19.084841!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c78ca22b8b01%3A0x618abd782986f3b2!2sSVK%20MAID%20SERVICES!5e0!3m2!1sen!2sin!4v1770359696044!5m2!1sen!2sin"
          loading="lazy"
          allowFullScreen
        ></iframe>
      </section>
    </>
  );
};

export default Hero;